module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_113_11.061d1abd.pdf";